var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useRef } from 'react';
import '../../../utils/Flows';
import WidgetButton from './WidgetButton';
import { MessageType, logEvent } from '../../../../../util/EventLog';
import { getURLParamValue } from '../../../../clearstep/util/AppHelpers';
import { WidgetStateChangeType } from '../../Widget';
import { trackEvent } from '../../../../clearstep/util/Split';
var extractWorkflowId = function (path) {
    var match = path.match(/\/workflows\/([^?]*)/);
    return match ? match[1] : null;
};
export var ChooseWorkflow = function (props) {
    var setWorkflow = props.setWorkflow, workflows = props.workflows;
    var toLog = useRef({ isQueued: false });
    useEffect(function () {
        window.addEventListener('message', function (event) {
            var _a, _b, _c, _d;
            if (event.origin === window.location.origin &&
                ((_a = event.data) === null || _a === void 0 ? void 0 : _a.type) === 'convo-started' &&
                ((_b = toLog === null || toLog === void 0 ? void 0 : toLog.current) === null || _b === void 0 ? void 0 : _b.isQueued) &&
                ((_c = toLog === null || toLog === void 0 ? void 0 : toLog.current) === null || _c === void 0 ? void 0 : _c.data) &&
                ((_d = toLog === null || toLog === void 0 ? void 0 : toLog.current) === null || _d === void 0 ? void 0 : _d.type)) {
                var _e = toLog.current, data = _e.data, type = _e.type;
                logEvent(type, __assign(__assign({}, data), { childConvoId: event.data.conversationId }));
                toLog.current = { isQueued: false };
            }
        });
    }, []);
    var storeLogData = function (flowInfo) {
        var sessionId = props.sessionId;
        toLog.current = {
            isQueued: true,
            type: MessageType.WIDGET_WORKFLOW_CLICKED,
            data: {
                parentUrl: getURLParamValue('parentUrl'),
                widgetSessionId: sessionId,
                workflowType: extractWorkflowId(flowInfo.path),
            },
        };
    };
    var logSplitData = function (flowInfo) {
        var sessionId = props.sessionId;
        trackEvent('user', 'widget_workflow_clicked', {
            properties: {
                parentUrl: getURLParamValue('parentUrl'),
                widgetSessionId: sessionId,
                workflowType: extractWorkflowId(flowInfo.path),
            },
        });
    };
    var handleSetWorkflow = function (flowInfo) {
        storeLogData(flowInfo); // Store data to log once we receive convo id from child
        setWorkflow(flowInfo, WidgetStateChangeType.MANUAL);
        logSplitData(flowInfo);
    };
    return (React.createElement("div", null,
        React.createElement("div", { className: "flex flex-col" }, workflows.map(function (flowInfo, i) { return (React.createElement(WidgetButton, { handleClick: function () {
                handleSetWorkflow(flowInfo);
            }, key: flowInfo.value, className: i !== workflows.length - 1 ? 'mb-2' : '' },
            React.createElement(React.Fragment, null, flowInfo.title))); }))));
};
export default ChooseWorkflow;
